/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-const */
import React, { useEffect } from 'react';
import { Page, Document, StyleSheet, View, usePDF } from '@react-pdf/renderer';
import FooterSection from './pdf-header-footer/footer-section';
import ProjectInfo from './project-info/project-info';
import { RationValWidth } from './fonts/font';

// Styles for the PDF document
const styles = StyleSheet.create({
  page: {
    lineHeight: 1.5,
    paddingBottom: RationValWidth(124),
  },
  body: {
    marginHorizontal: RationValWidth(56),
  }
});
// Main component to generate a PDF report
const ArgoReport = ({ cipReportData, reportDataObj }) => {
  // let serialNum = 1;
  // let subSerialNum = 1;

  return (
    <Document>
      <Page size='A4' object-fit='fill' style={styles.page} bookmark='Preface'>
        <View style={styles.body}>
          <ProjectInfo
            pageWidth={1140}
            cipReportData={cipReportData}
            reportDataObj={reportDataObj}
          />
        </View>
        <FooterSection />
      </Page>
    </Document>
  );
};
const Createpdf = (props) => {
  const { setCipPdfReport, cipReportData, reportDataObj, setFetchLoading } = props;
  const [instance] = usePDF({ document: <ArgoReport cipReportData={cipReportData} reportDataObj={reportDataObj} /> });
  useEffect(() => {
    if (instance && instance.url) {
      const link = document.createElement('a'); // @sudarsana creating anchor tag here after clicking generator button
      link.href = instance.url;
      link.setAttribute('download', 'cipReport.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setFetchLoading(false);
      setCipPdfReport(false);
    }
  }, [instance]);
  return null;
};
export default Createpdf;